export const CREATING_COLLECTION = 'Creating Collection';
export const RETRIEVING_ALL_COLLECTIONS = 'Retrieving All Collections';
export const UPDATING_COLLECTION = 'Updating Collection';
export const DELETING_COLLECTION = 'Deleting Collection';
